import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginProposalComponent } from './login-proposal/login-proposal.component';

const routes: Routes = [
  {
    path: '',
    component: LoginProposalComponent,
  },
  {
    path: 'forms',
    loadChildren: () => import('./../forms/forms.module').then(m => m.FormsProposalModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [Location],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
